<template>
  <div v-if="order && order.consigneeInfo" :class="_.block">
    <!-- 物流 -->

    <template v-if="!noExpress">
      <div v-if="order.selfAddress">
        <div
          v-track="{
            name: '我的订单-物流',
            id: '8f879cf0-7a62-4f41-9a98-17fd20468977',
          }"
          :class="[_.express, _._hairlineBottom]"
          @click="handleExpressClick()"
        >
          <img :src="require('./images/收件人.png')" :class="_.icon" />
          <div :class="_.content">
            <div :class="_.title">该商品已选择线下自提</div>
            <div :class="_.desc">
              {{ order.selfAddress.name }}
              <span>{{ order.selfAddress.phoneNo }}</span>
              {{
                `${order.selfAddress.province}${order.selfAddress.city}${order.selfAddress.area}${order.selfAddress.detail}`
              }}
            </div>
          </div>
          <x-icon name="arrow" :class="_.arrow" />
        </div>
      </div>

      <div v-else-if="order.shippingType === 5">
        <div
          :class="[_.express, _._hairlineBottom]"
          @click="handlePhoneClick(order.merchantCourier.courierPhone)"
        >
          <img :src="require('./images/收件人.png')" :class="_.icon" />
          <div :class="_.content">
            <div :class="_.title">商家自配送，配送进度查询请联系配送员</div>
            <div :class="_.desc">
              {{ order.merchantCourier.courierName }}
              <span> {{ order.merchantCourier.courierPhone }}</span>
              <van-icon name="phone" :class="_.phone"></van-icon>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="
          order.consigneeInfo.packageQuantity !== 0 &&
          (order.consigneeInfo.packageType === 2 ||
            (expressData.traces && expressData.traces.length))
        "
        v-track="{
          name: '我的订单-物流',
          id: '8f879cf0-7a62-4f41-9a98-17fd20468977',
        }"
        :class="[
          _.express,
          order.consigneeInfo.packageType === 2 && _.center,
          _._hairlineBottom,
        ]"
        @click="
          ;(order.consigneeInfo.packageType === 2 ||
            (expressData.traces && expressData.traces[0])) &&
            handleExpressClick()
        "
      >
        <img :src="require('./images/收件人.png')" :class="_.icon" />
        <div :class="_.content">
          <div
            v-if="order.consigneeInfo.packageType === 1 && expressData.state"
            :class="_.title"
          >
            {{ expressData.state }}
          </div>
          <div :class="_.desc">
            {{
              order.consigneeInfo.packageType === 1
                ? expressData.traces[0]
                  ? expressData.traces[0].actionInfo
                  : '暂无物流信息'
                : `该订单已拆成${order.consigneeInfo.packageQuantity}个包裹发出，点击查看物流详情`
            }}
          </div>
          <div
            v-if="
              order.consigneeInfo.packageType === 1 && expressData.traces[0]
            "
            :class="_.time"
          >
            {{ expressData.traces[0].actionTime }}
          </div>
        </div>
        <x-icon
          v-if="expressData.traces && expressData.traces[0]"
          name="arrow"
          :class="_.arrow"
        />
      </div>
    </template>

    <!-- 收件人 -->
    <div :class="_.consignee">
      <img :src="require('./images/地址.png')" :class="_.icon" />
      <div :class="_.content">
        <div :class="_.user">
          <div :class="_.name">{{ order.consigneeInfo.name }}</div>
          <div :class="_.phone">{{ order.consigneeInfo.tel }}</div>
        </div>
        <div :class="_.address">
          {{
            `${order.consigneeInfo.province}${order.consigneeInfo.city}${order.consigneeInfo.area}${order.consigneeInfo.address}`
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { apiOrderOrderQueryLogistics } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { navigateTo } from '@/router'
  import { prepareData } from '@/utils'

  export default Vue.extend({
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        // 物流信息
        expressData: {},
      }
    },

    computed: {
      noExpress() {
        return ['1566001890423336960', '1567171020530774016'].includes(
          this.order.merchantId,
        )
      },
    },

    async mounted() {
      const { expressData } = await prepareData({
        expressData:
          this.order.consigneeInfo.packageType === 1
            ? apiOrderOrderQueryLogistics(
                {
                  orderNo: this.order.orderNo,
                },
                {
                  noErrorToast: true,
                },
              ).catch(() => ({}))
            : {},
      })
      this.expressData = expressData
    },

    methods: {
      // 点击查看物流
      handleExpressClick() {
        navigateTo('ExpressIndex', {
          orderNo: this.order.orderNo,
        })
      },
      // 拨打电话
      handlePhoneClick(phone) {
        dcb.makePhoneCall({
          phoneNumber: phone,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .block {
    margin-top: 12px;
    padding: 12px;
    background: #ffffff;
    border-radius: 8px;
  }

  .express {
    display: flex;
    align-items: flex-start;
    padding-bottom: 12px;
    margin-bottom: 12px;

    &.center {
      align-items: center;
    }

    .icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      padding-top: 2px;
    }

    .content {
      flex-grow: 1;
      margin-left: 8px;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      .desc {
        font-size: 12px;
        color: #222222;
        line-height: 16px;

        &:not(:first-child) {
          margin-top: 4px;
        }

        span {
          color: #00acff;
        }
        .phone {
          flex-shrink: 0;
          margin-left: 10px;
          align-self: center;
          font-size: 14px;
          color: #00acff;
        }
      }

      .time {
        margin-top: 8px;
        font-size: 12px;
        color: #888888;
        line-height: 16px;
      }
    }

    .arrow {
      flex-shrink: 0;
      margin-left: 23px;
      align-self: center;
      font-size: 14px;
      color: #666;
    }
  }

  .consignee {
    display: flex;
    align-items: flex-start;

    .icon {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      padding-top: 2px;
    }

    .content {
      flex-grow: 1;
      margin-left: 8px;

      .user {
        display: flex;
        align-items: center;

        .name {
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        .phone {
          margin-left: 8px;
          font-size: 14px;
          color: #888888;
          line-height: 20px;
        }
      }

      .address {
        margin-top: 6px;
        font-size: 12px;
        color: #222222;
        line-height: 16px;
      }
    }
  }
</style>
